import holiday_jp from '@holiday-jp/holiday_jp';

// {key: value} ペアのオブジェクトを、URL用のクエリstring '?key=value' に変換する
export const queryConfigToString = (queryConfig: object): string => {
  if (queryConfig === undefined) {
    return ''
  }
  const keyAndValues = Object.entries(queryConfig)
  const queries = keyAndValues.map(keyValue => {
    return `${keyValue[0]}=${keyValue[1]}`
  })
  const query = queries.join('&')
  return `?${query}`
}

export const dateToYesterday = (date: Date): Date => {
  let yesterday = new Date(date)
  yesterday.setDate(yesterday.getDate() - 1)
  return yesterday
}

export const daysOfWeek = (date: Date): '日' | '月' | '火' | '水' | '木' | '金' | '土' => {
  const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][
    date.getDay()
  ]
  return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土'
}

export const createNumOptions = (from: number, to: number, suffixLabel = '') => {
  const range = to - from + 1;
  const arr = Array.from(Array(range).keys()).map(val => val + from);

  return arr.map(val => {
    return {
      text: val.toString() + suffixLabel,
      value: val.toString()
    }
  });
}

export const formatDayOfWeek = (date:Date, wday_holiday:Boolean = false) => {
  if (date) {
    if (holiday_jp.isHoliday(date)) {
      return ( wday_holiday ? ['日', '月', '火', '水', '木', '金', '土'][date.getDay()] + '・祝'
                            : '祝' )
    } else {
      return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()]
    }
  }

  return '-'
}

export const formatDate = (date: Date, format: string) => {
  switch(format) {
    case 'ja-long':
      return  `${date.getMonth() + 1}月${date.getDate()}日（${daysOfWeek(date)}）`
    case 'ja-short':
      return `${date.getMonth() + 1}月${date.getDate()}日（${daysOfWeek(date)}）`
    case '/':
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}（${daysOfWeek(date)}）`
  }
  return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}（${daysOfWeek(date)}）`
}

export const monthOptions = createNumOptions(1, 12);
export const dayOptions = createNumOptions(1, 31);
export const yearOptions = createNumOptions(1900, 2015).reverse();
